import React from 'react';
import { useRouter } from 'next/router';
import { Typography } from '@mui/material';
import { Dropdown, useI18nContext } from '@procore/core-react';
import { sendAnalyticsEvent } from '../Analytics/utilities';

export const RADIUS_OPTIONS = [25, 50, 100, 200];

const returnDistanceString = (locale: string, I18n: any, distance: number) => {
  if (locale === 'en-US') {
    return I18n.t('components.search_radius_selector.miles', {
      selected: distance,
    });
  }
  return I18n.t('components.search_radius_selector.kilometers', {
    selected: Math.round(distance * 1.61),
  });
};

const SearchRadiusSelector = ({ onChange, value }) => {
  const { locale } = useRouter();
  const I18n = useI18nContext();
  return (
    <Dropdown
      data-test-id="radius-selector"
      // @ts-ignore
      label={
        <Typography component="h2" variant="h3">
          {returnDistanceString(locale, I18n, value)}
        </Typography>
      }
      onSelect={({ item }) => {
        sendAnalyticsEvent('Selected Radius', item, 'Clicked Dropdown Item');
        onChange(item);
      }}
    >
      {RADIUS_OPTIONS.map((radius) => {
        const distanceInMiles = locale === 'en-US' ? radius : radius / 1.61;
        return (
          <Dropdown.Item
            key={`radius-${distanceInMiles}`}
            item={distanceInMiles}
          >
            {returnDistanceString(locale, I18n, distanceInMiles)}
          </Dropdown.Item>
        );
      })}
    </Dropdown>
  );
};

export default SearchRadiusSelector;
